import { action, makeObservable, observable } from "mobx";
import { fetchResource } from "../utilities";
import { isValid } from "postcode";
import BaseService from "./base/BaseService";
import { POSTCODE_LOOKUP_URL } from "../configs/api-paths";

/**
 * MobX service containing form data. It can send data to server.
 */
class PostcodeLookupService extends BaseService {
	/**
	 * Suggestions for addresses generated by using postcode.
	 * @type {{}}
	 */
	@observable
	postcodeData = {};

	constructor(props) {
		super(props);
		makeObservable(this);
	}

	@action
	setPostcodeData = (postcodeData) => {
		this.postcodeData = postcodeData;
	};

	loadPostcodeData = async (rawPostcode) => {
		if (!rawPostcode || rawPostcode === "") {
			return;
		}

		let postcode = rawPostcode.trim().toLowerCase();

		if (!isValid(postcode)) {
			return;
		}

		try {
			const result = await fetchResource(
				`${POSTCODE_LOOKUP_URL}${postcode}?expand=true&fuzzy=true`
			);

			const postcodeLookupData = await result.json();

			this.setPostcodeData({
				postcode: postcodeLookupData.postcode,
				addresses: postcodeLookupData.addresses,
			});
		} catch (error) {
			console.log(error);
		}
	};
}

export default PostcodeLookupService;
